export var PROFILE_TAB_VALUES = [
    "nfts",
    "coins",
    "swap",
    "listings",
    "received-offers",
    "made-offers",
    "activity",
];
export var PROFILE_BASE_PATH = "/profile";
export var DEFAULT_PROFILE_TAB = "coins";
export var isProfileTabValue = function (value) {
    return PROFILE_TAB_VALUES.includes(value);
};
export var getProfileTabPath = function (tabValue) {
    return "".concat(PROFILE_BASE_PATH, "/").concat(tabValue);
};
export var getProfileTabFromPathname = function (pathname) {
    var normalizedPathname = pathname.replace(/\/+$/, "") || "/";
    if (normalizedPathname === "/" ||
        normalizedPathname === PROFILE_BASE_PATH) {
        return DEFAULT_PROFILE_TAB;
    }
    var maybeTabValue = normalizedPathname.startsWith("".concat(PROFILE_BASE_PATH, "/"))
        ? normalizedPathname.slice("".concat(PROFILE_BASE_PATH, "/").length)
        : normalizedPathname.slice(1);
    return isProfileTabValue(maybeTabValue) ? maybeTabValue : DEFAULT_PROFILE_TAB;
};
